import { SHOW_WIZARD,SET_CURRNET_WIZRD_PAGE,SET_CURRNET_WIZRD,
  SET_WIZARD_ERROR_MESSAGE,SET_WIZARD_CATEGORY, SET_CURRENT_WIZARD_DATA, CLEAR_WIZARD } from "./types";

export const showWizard = (status:boolean) => (dispatch: any) => {
    dispatch({
      type: SHOW_WIZARD,
      payload: status,
    });
};

export const setWizardPage = (page:number) => (dispatch: any) => {
  dispatch({
    type: SET_CURRNET_WIZRD_PAGE,
    payload: page,
  });
};
export const setWizard = (wizard:string) => (dispatch: any) => {
  dispatch({
    type: SET_CURRNET_WIZRD,
    payload: wizard,
  });
};
export const setWizardErrorMsg = (error:string) => (dispatch: any) => {
  dispatch({
    type: SET_WIZARD_ERROR_MESSAGE,
    payload: error,
  });
};

export const setWizardCategory = (category:string) => (dispatch: any) => {
  dispatch({
    type: SET_WIZARD_CATEGORY,
    payload: category,
  });
};
/**
 * arbitary function for setting the data object for the current wizard that is used by the tutorial.
 * @param data 
 * @returns 
 */
export const setCurrentWizardData = (data:any) => (dispatch: any) => {
  dispatch({
    type: SET_CURRENT_WIZARD_DATA,
    payload: data,
  });
};

export const clearWizard = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_WIZARD,
    payload: {},
  });
};